import { Typography } from '@mui/material'

import { type IColumn } from 'packages/ui/Table'

import { formatDate, formatNumber } from '../../utils'

const COLUMNS_CONFIG: IColumn[] = [
  {
    name: 'name',
    header: {
      label: (ctx) => ctx.t('mailing.history.column_name')
    },
    style: {
      minWidth: 220
    },
    value: (item) => (
      <Typography component="span" sx={{ color: '#464646', fontSize: 12, fontWeight: 500 }}>
        {String(item.name || '-')}
      </Typography>
    )
  },
  {
    name: 'email_count',
    header: {
      label: (ctx) => ctx.t('mailing.history.column_email_count')
    },
    style: {
      minWidth: 130
    },
    value: (item) => formatNumber(Number(item.email_count ?? 0))
  },
  {
    name: 'created_at',
    header: {
      label: (ctx) => ctx.t('mailing.history.column_created_at')
    },
    style: {
      minWidth: 150
    },
    value: (item) => formatDate(item.created_at)
  }
]

export default COLUMNS_CONFIG
